export const BASE_FORM_8973_PATH = "/form-8973";
